import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import ContactUsForm from "components/forms/TwoColContactUsWithIllustrationFullForm.js";
import ContactDetails from "components/cards/ThreeColContactDetails.js";

import HeaderBase, {
  LogoLink as LogoLinkBase,
  NavLinks,
  NavLink as NavLinkBase,
  PrimaryLink as PrimaryLinkBase,
} from "components/headers/light.js";
import logoImageSrc from "images/logo.png";
import logo from "images/logo.png";
import { ContentWithPaddingXl } from "components/misc/Layouts";
const NavLink = tw.a`mt-4 lg:mt-0 transition duration-300 font-medium pb-1 border-b-2 mr-12 text-gray-700 border-gray-400 hocus:border-gray-700`;
const PrimaryNavLink = tw(
  NavLink
)`text-gray-100 bg-blue-500 px-6 py-3 border-none rounded hocus:bg-blue-900 focus:shadow-outline mt-6 md:mt-4 lg:mt-0`;
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Row = tw.div`flex`;

const NavRow = tw(Row)`flex flex-col lg:flex-row items-center justify-between`;
const Address = tw.span`leading-relaxed`;
const AddressLine = tw.span`block`;
const Email = tw.span`text-sm mt-6 block text-gray-500`;
const Phone = tw.span`text-sm mt-0 block text-gray-500`;

export default () => {
  const Header = tw(
    HeaderBase
  )`max-w-none -mt-8 py-8 -mx-8 px-8 bg-blue-900 bg-blue-900`;
  const NavLink = tw(
    NavLinkBase
  )`lg:text-gray-100 lg:hocus:text-gray-300 lg:hocus:border-gray-100`;
  const LogoLink = tw(LogoLinkBase)`text-gray-100 hocus:text-gray-300`;
  const PrimaryLink = tw(
    PrimaryLinkBase
  )`shadow-raised lg:bg-blue-400 lg:hocus:bg-blue-500`;

  const navLinks = [
    <NavLinks key={1}>
      <NavLink href="/components/innerPages/AboutUsPage">About Us</NavLink>
      <NavLink href="/components/innerPages/ProjectsPage">Projects</NavLink>
      <NavLink href="/components/innerPages/BlogIndexPage">Services</NavLink>
      <PrimaryLink href="/components/innerPages/ContactUsPage">
        Get A Quote
      </PrimaryLink>
    </NavLinks>,
  ];

  const logoLink = (
    <LogoLink href="/">
      <img src={logoImageSrc} alt="Logo" />
      Great Wave Digital
    </LogoLink>
  );

  return (
    <>
      <ContentWithPaddingXl></ContentWithPaddingXl>
      <AnimationRevealPage>
        <ContactUsForm />
        {/* <ContactDetails
        cards={[
          {
            title: "New York",
            description: (
              <>
                <Address>
                  <AddressLine>40 Gates Court</AddressLine>
                  <AddressLine>Endicott, NY 13760</AddressLine>
                </Address>
                <Email>contact@treact.com</Email>
                <Phone>+1 (203) 991-6988</Phone>
              </>
            ),
          },
          {
            title: "Illinois",
            description: (
              <>
                <Address>
                  <AddressLine>602 Annadale Drive</AddressLine>
                  <AddressLine>Dekalb, IL 60115</AddressLine>
                </Address>
                <Email>contact@treact.com</Email>
                <Phone>+1 (203) 991-6988</Phone>
              </>
            ),
          },
          {
            title: "California",
            description: (
              <>
                <Address>
                  <AddressLine>96 NE. Delaware Lane</AddressLine>
                  <AddressLine>Sacramento, CA 95820</AddressLine>
                </Address>
                <Email>contact@treact.com</Email>
                <Phone>+1 (203) 991-6988</Phone>
              </>
            ),
          },
          {
            title: "Tennessee",
            description: (
              <>
                <Address>
                  <AddressLine>74 Peachtree Ave.</AddressLine>
                  <AddressLine>Dyersburg, TN 38024</AddressLine>
                </Address>
                <Email>contact@treact.com</Email>
                <Phone>+1 (203) 991-6988</Phone>
              </>
            ),
          },
          {
            title: "New Jersey",
            description: (
              <>
                <Address>
                  <AddressLine>8355 Summer Street</AddressLine>
                  <AddressLine>Manchester, NJ 08759</AddressLine>
                </Address>
                <Email>contact@treact.com</Email>
                <Phone>+1 (203) 991-6988</Phone>
              </>
            ),
          },
          {
            title: "Ohio",
            description: (
              <>
                <Address>
                  <AddressLine>7713 Snake Hill Ave.</AddressLine>
                  <AddressLine>Piqua, OH 45356</AddressLine>
                </Address>
                <Email>contact@treact.com</Email>
                <Phone>+1 (203) 991-6988</Phone>
              </>
            ),
          },
        ]}
      /> */}
      </AnimationRevealPage>
    </>
  );
};
